import { Component } from '@angular/core';
import { FilterComponent } from '../filter.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-filter-inline',
  templateUrl: './filter-inline.component.html'
})
export class FilterInlineComponent extends FilterComponent {
  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    super.ngOnInit();
    this.onFormChange();
  }

  /**
   * Handles all form controls changes without input
   */
  onFormChange(): void {
    // Excludes input from the subscriber, because we have special debounce processing for input control
    const merged = this.formGroupService.mergeValueChangesByFormControlWithoutExcluded(['filter'], this.form);

    if (!merged) {
      return;
    }

    merged.pipe(takeUntil(this.destroyNotify)).subscribe(() => {
      this.emitFilterChange();
    });
  }

  emitFilterChange(): void {
    const result = this.convertFormControlToRecord();
    this.filterChange.emit(result);
    this.formChange = { change: true };
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}